import { render, staticRenderFns } from "./CallBack.vue?vue&type=template&id=54d1ef7e&scoped=true"
import script from "./CallBack.vue?vue&type=script&lang=js"
export * from "./CallBack.vue?vue&type=script&lang=js"
import style0 from "./CallBack.vue?vue&type=style&index=0&id=54d1ef7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d1ef7e",
  null
  
)

export default component.exports